<template>
  <div id="pageNotFound">
    <img src="../../../assets/icon/404.jpg" class="background-img-404">
    <div class="pageNotFound-content">
      <div class="pageNotFound-label pageNotFound-label1">哎呀，您访问的页面可能我们蛋糕师傅还未制作出来哟！</div>
      <div class="pageNotFound-label pageNotFound-label2">请刷新页面试试</div>
    </div>

    <img/>
  </div>
</template>

<script>

  export default {
    name: 'pageNotFound',
    mounted () {
    },
    destroyed () {
    },
    computed: {
    },
    data () {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';

  .background-img-404 {

    position: absolute;
    height: 100%;
    width: 100%;
  }

  .pageNotFound-label {
    background-color: white;
    margin-bottom: pxToRem(50px);
  }

  .pageNotFound-content {
    position: absolute;
    top: pxToRem(260px);
    height: pxToRem(100px);
    left: 0px;
    right: 0px;
    color: #575757;
    font-size: pxToRem(26px);
    text-align: center;

  }
  
</style>


// WEBPACK FOOTER //
// pageNotFound.vue?4f79c18c